// extracted by mini-css-extract-plugin
export default {"fastChart":"FastChart_fastChart__VYy4t"};